import { filtersByMailType } from "../../features/filter-sheets/utils";
import { IArtifactDetails } from "../../endpoints/getArtifactDetailsById";
import { StatusEnum } from "../../endpoints/getArtifacts";

export interface ITableProps {
    data?: any;
    header?: any;
    onSearch?: boolean;
    tableQueryParams?: any;
    tableUseCase?: string;
    tableName?: string;
    hideTableHeader?: boolean;
    inputPageSize?: string;
    tableRef?: any;
    extraHelperButtons?: { props: any; label: string; actions: (value: any) => any }[];
    showDividers?: boolean;
}

export const defaultMailStatuses = [
    StatusEnum.UNREAD,
    StatusEnum.OPEN,
    StatusEnum.CLOSED,
    StatusEnum.OVERDUE,
];

export const appealStatus = [
    StatusEnum.NEW,
    StatusEnum.PREPARING,
    StatusEnum.UNDER_APPEAL,
    StatusEnum.COMPLETE,
    StatusEnum.NOT_APPEALED,
];

export interface ITableRowProps {
    data: IArtifactDetails[];
    currentRow: number;
    currentTable: string;
    headers: any;
}

export const commonTableHeaderCells = [
    {
        id: "address",
        subId: "jurisdiction",
        label: "Jurisdiction",
        displayType: "JURISDICTION",
        order: 5,
    },
    { id: "address", subId: "state", label: "State", displayType: "STATE", order: 5 },
    { id: "mailId", displayType: "LINK", label: "Mail Id", order: 1 },
    {
        id: "receiveDate",
        label: "Received Date",
        displayType: "DATE",
        sortValue: "receiveDate",
        order: 3,
    },
    {
        id: "dueDate",
        label: "Due Date",
        displayType: "DATE",
        sortValue: "dueDate",
        order: 7,
    },
    {
        id: "updatedOn",
        displayType: "DATE",
        sortValue: "updatedOn",
        label: "Last Updated On",
        order: 7,
    },
    { id: "assignedTo", label: "Assigned To", order: 7 },
    { id: "status", displayType: "STATUS", label: "Status", order: 9 },
];

export const commonPPTableHeaderCells = [
    { id: "accountNumber", displayType: "LINK", label: "Account Number", sortValue: "", order: 2 },
];

export const commonRETableHeaderCells = [
    { id: "parcelNumber", displayType: "LINK", label: "Parcel Number", sortValue: "", order: 2 },
];

export const taxBillsPPTableHeaderCells = [
    ...commonTableHeaderCells,
    ...commonPPTableHeaderCells,
    {
        id: "earliestPaymentDueDate",
        label: "Earliest Payment Due Date",
        displayType: "DATE",
        sortValue: "",
        order: 4,
    },
    {
        id: "trueAmountDueAmount",
        displayType: "CURRENCY",
        label: "True Amount Due",
        sortValue: "",
        order: 4,
    },
];

export const taxReturnsPPTableHeaderCells = [
    ...commonTableHeaderCells,
    ...commonPPTableHeaderCells,
    { id: "filingDueDate", displayType: "DATE", label: "Filing Due Date", sortValue: "", order: 4 },
];

export const valueNoticePPTableHeaderCells = [
    ...commonTableHeaderCells,
    ...commonPPTableHeaderCells,
    {
        id: "appealDeadline",
        displayType: "DATE",
        label: "Appealing Deadline",
        sortValue: "",
        order: 4,
    },
    {
        id: "taxBillEstimateAmount",
        displayType: "CURRENCY",
        label: "Tax Bill Estimate",
        sortValue: "",
        order: 4,
    },
];
export const hearingNoticePPTableHeaderCells = [
    ...commonTableHeaderCells,
    ...commonPPTableHeaderCells,
    { id: "dateOfHearing", displayType: "DATE", label: "Date Of Hearing", sortValue: "", order: 4 },
];

export const checksPPTableHeaderCells = [...commonTableHeaderCells, ...commonPPTableHeaderCells];

export const taxBillRETableHeaderCells = [
    ...commonTableHeaderCells,
    ...commonRETableHeaderCells,
    {
        id: "earliestPaymentDueDate",
        label: "Earliest Payment Due Date",
        displayType: "DATE",
        sortValue: "",
        order: 4,
    },
    {
        id: "totalTaxesOwedAmount",
        displayType: "CURRENCY",
        label: "Total Taxes Owed",
        sortValue: "",
        order: 4,
    },
];

export const valueNoticeRETableHeaderCells = [
    ...commonTableHeaderCells,
    ...commonRETableHeaderCells,
    { id: "appealDeadline", label: "Appealing Deadline", sortValue: "", order: 4 },
    {
        id: "taxBillEstimateAmount",
        displayType: "CURRENCY",
        label: "Tax Bill Estimate",
        sortValue: "",
        order: 4,
    },
];

export const hearingNoticeRETableHeaderCells = [
    ...commonTableHeaderCells,
    ...commonRETableHeaderCells,
    { id: "dateOfHearing", displayType: "DATE", label: "Date Of Hearing", sortValue: "", order: 4 },
];

export const checksRETableHeaderCells = [
    ...commonTableHeaderCells,
    ...commonRETableHeaderCells,
    { id: "checkNumber", label: "Check Number", sortValue: "", order: 4 },
];

export const miscellaneousHeaderCells = [...commonTableHeaderCells];
export const unsortedHeaderCells = [
    ...commonTableHeaderCells,
    { id: "failureReason", label: "Failure reason", sortValue: "" },
];
export const propertyHeaderCells = [
    { id: "propertyNumber", displayType: "LINK", label: "Property Id", sortValue: "" },
    { id: "address", label: "Property Address", sortValue: "" },
    { id: "status", displayType: "STATUS", label: "Status", order: 9 },
];
export const parcelHeaderCells = [
    { id: "parcelNumber", displayType: "LINK", label: "Parcel Number", sortValue: "" },
    { id: "address", label: "Parcel Address", sortValue: "" },
    { id: "status", displayType: "STATUS", label: "Status", order: 9 },
];

export const assignedToMeHeaderCells = [
    { id: "mailId", displayType: "LINK", label: "Mail Id", order: 1 },
    {
        id: "receiveDate",
        label: "Received Date",
        displayType: "DATE",
        sortValue: "receiveDate",
        order: 3,
    },
    {
        id: "dueDate",
        label: "Due Date",
        displayType: "DATE",
        sortValue: "dueDate",
        order: 3,
    },
    {
        id: "updatedOn",
        displayType: "DATE",
        sortValue: "updatedOn",
        label: "Last Updated On",
        order: 7,
    },
    { id: "assignedTo", label: "Assigned To", order: 7 },
    { id: "status", displayType: "STATUS", label: "Status", order: 9 },
];

export const auditRecordMailsHeaderCells = [
    { id: "fileName", displayType: "PRE_SIGNED_URL", label: "File name", sortValue: "" },
    { id: "fileSizeInMB", label: "File size (MB)", sortValue: "" },
    { id: "fileType", label: "File type", sortValue: "" },
    { id: "uploadedBy", label: "Uploaded by", sortValue: "" },
    { id: "uploadTimeStamp", displayType: "DATE", label: "Uploaded time", sortValue: "" },
    { id: "status", displayType: "STATUS", label: "Status", order: 9 },
];

export const auditRecordDataSourceFilesHeaderCells = [
    { id: "fileName", displayType: "PRE_SIGNED_URL", label: "File name", sortValue: "" },
    { id: "fileSizeInMB", label: "File size (MB)", sortValue: "" },
    { id: "dataType", label: "Type", sortValue: "" },
    { id: "uploadedBy", label: "Uploaded by", sortValue: "" },
    { id: "uploadTimeStamp", displayType: "DATE", label: "Uploaded date", sortValue: "" },
    { id: "status", displayType: "STATUS", label: "Status", order: 9 },
];

export const openAssessmentsHeaderCells = [
    { id: "siteCode", displayType: "LINK", label: "Site code", sortValue: "", order: 1 },
    { id: "year", label: "Tax year", sortValue: "", order: 2 },
    { id: "dueDate", label: "Due date", sortValue: "dueDate", order: 3 },
    {
        id: "totalValue",
        displayType: "CURRENCY",
        label: "Market value",
        sortValue: "marketValue",
        order: 3,
    },
    {
        id: "indicatedValue",
        displayType: "CURRENCY",
        label: "Estimate",
        sortValue: "indicatedValue",
        order: 5,
    },
    {
        id: "difference",
        displayType: "CURRENCY",
        label: "Difference",
        sortValue: "difference",
        order: 6,
    },
    { id: "status", displayType: "STATUS", label: "Status", order: 9 },
];

export const propertyPageSpacesHeaderCells = [
    { id: "spaceName", label: "Space name", sortValue: "", order: 1 },
    { id: "area", label: "Area (sqft)", sortValue: "area", order: 2 },
    { id: "status", label: "Status", sortValue: "", order: 3 },
];

export const tableMapping = {
    "tax-bill-personal": {
        label: "Tax bills (Personal)",
        tableHeader: taxBillsPPTableHeaderCells,
        filter: filtersByMailType["tax-bill-personal"],
        propertyType: "PERSONAL_PROPERTY",
        documentType: "TAX_BILL",
        status: defaultMailStatuses,
        emptyMessage: "No tax bill mails to display",
    },
    "tax-return-personal": {
        label: "Tax returns (Personal)",
        tableHeader: taxReturnsPPTableHeaderCells,
        filter: filtersByMailType["tax-return-personal"],
        propertyType: "PERSONAL_PROPERTY",
        documentType: "TAX_RETURN",
        status: defaultMailStatuses,
        emptyMessage: "No tax return mails to display",
    },
    "tax-return-real": {
        label: "Tax returns (Real)",
        tableHeader: [],
    },
    "value-notice-personal": {
        label: "Value Notices (Personal)",
        tableHeader: valueNoticePPTableHeaderCells,
        filter: filtersByMailType["value-notice-personal"],
        propertyType: "PERSONAL_PROPERTY",
        documentType: "VALUE_NOTICE",
        status: defaultMailStatuses,
        emptyMessage: "No value notice mails to display",
    },
    "hearing-notice-personal": {
        label: "Hearing notices (Personal)",
        tableHeader: hearingNoticePPTableHeaderCells,
        filter: filtersByMailType["hearing-notice-personal"],
        propertyType: "PERSONAL_PROPERTY",
        documentType: "HEARING_NOTICE",
        status: defaultMailStatuses,
        emptyMessage: "No hearing notice mails to display",
    },
    "check-personal": {
        label: "Checks (Personal)",
        tableHeader: checksPPTableHeaderCells,
        filter: filtersByMailType["check-personal"],
        propertyType: "PERSONAL_PROPERTY",
        documentType: "CHECK",
        status: defaultMailStatuses,
        emptyMessage: "No check mails to display",
    },
    "tax-bill-real": {
        label: "Tax bills (Real)",
        tableHeader: taxBillRETableHeaderCells,
        filter: filtersByMailType["tax-bill-real"],
        propertyType: "REAL_PROPERTY",
        documentType: "TAX_BILL",
        pluralVersion: "Tax bills (Real)",
        status: defaultMailStatuses,
        emptyMessage: "No tax bill mails to display",
    },
    "value-notice-real": {
        label: "Value notices (Real)",
        tableHeader: valueNoticeRETableHeaderCells,
        filter: filtersByMailType["value-notice-real"],
        propertyType: "REAL_PROPERTY",
        documentType: "VALUE_NOTICE",
        status: defaultMailStatuses,
        emptyMessage: "No value notice mails to display",
    },
    "hearing-notice-real": {
        label: "Hearing notices (Real)",
        tableHeader: hearingNoticeRETableHeaderCells,
        filter: filtersByMailType["hearing-notice-real"],
        propertyType: "REAL_PROPERTY",
        documentType: "HEARING_NOTICE",
        status: defaultMailStatuses,
        emptyMessage: "No hearing notice mails to display",
    },
    "check-real": {
        label: "Checks (Real)",
        tableHeader: checksRETableHeaderCells,
        filter: filtersByMailType["check-real"],
        propertyType: "REAL_PROPERTY",
        documentType: "CHECK",
        status: defaultMailStatuses,
        emptyMessage: "No checks to display",
    },
    "miscellaneous-real": {
        tableHeader: miscellaneousHeaderCells,
        filter: filtersByMailType["miscellaneous"],
        label: "Miscellaneous",
        documentType: "MISCELLANEOUS",
        propertyType: "REAL_PROPERTY",
        status: defaultMailStatuses,
        emptyMessage: "No miscellaneous to display",
    },
    "miscellaneous-personal": {
        tableHeader: miscellaneousHeaderCells,
        filter: filtersByMailType["miscellaneous"],
        label: "Miscellaneous",
        documentType: "MISCELLANEOUS",
        propertyType: "PERSONAL_PROPERTY",
        status: defaultMailStatuses,
        emptyMessage: "No miscellaneous to display",
    },
    "unsorted-mails": {
        tableHeader: unsortedHeaderCells,
        filter: filtersByMailType["common-filters"],
        label: "Mails not sorted",
        status: ["FAILED"],
        emptyMessage: "No unsorted mails to display",
    },
    "overdue-mails": {
        tableHeader: commonTableHeaderCells,
        filter: filtersByMailType["common-filters"],
        label: "Mails overdue",
        assignedTo: false,
        status: ["OVERDUE"],
        emptyMessage: "No overdue mails to display",
    },
    "overdue-mails-to-me": {
        tableHeader: commonTableHeaderCells,
        filter: filtersByMailType["common-filters"],
        label: "Mails overdue",
        assignedTo: true,
        status: ["OVERDUE"],
        emptyMessage: "No overdue mails to display",
    },
    "assigned-to-me": {
        tableHeader: assignedToMeHeaderCells,
        filter: filtersByMailType["common-filters"],
        label: "Assigned to me",
        assignedTo: true,
        status: defaultMailStatuses,
        emptyMessage: "No mails to display",
    },
    "calender-event": {
        tableHeader: assignedToMeHeaderCells,
        filter: filtersByMailType["calender-event"],
        label: "current Date",
        emptyMessage: "No events to display",
    },
    property: {
        tableHeader: propertyHeaderCells,
        filter: filtersByMailType["property"],
        label: "Property",
        artifactType: "REAL_PROPERTY",
        emptyMessage: "No properties to display",
    },
    parcel: {
        tableHeader: parcelHeaderCells,
        filter: filtersByMailType["parcel"],
        label: "Parcel",
        artifactType: "PARCEL",
        emptyMessage: "No parcels to display",
    },

    "audit-records-mails": {
        tableHeader: auditRecordMailsHeaderCells,
        filter: filtersByMailType["audit-records-mails"],
        label: "Audit records",
        emptyMessage: "No audit records to display",
        displayAdditionCells: false,
    },
    "audit-records-data-source-files": {
        tableHeader: auditRecordDataSourceFilesHeaderCells,
        filter: filtersByMailType["audit-records-data-source-files"],
        label: "Audit records",
        emptyMessage: "No audit records to display",
        displayAdditionCells: false,
    },
    "open-assessments": {
        tableHeader: openAssessmentsHeaderCells,
        filter: null,
        label: "Open property assessments",
        emptyMessage: "No open property assessments to display",
        status: appealStatus,
        displayAdditionCells: false,
    },
    "property-page-spaces": {
        tableHeader: propertyPageSpacesHeaderCells,
        filter: null,
        label: "",
        emptyMessage: "No property spaces to display",
        displayAdditionCells: false,
    },
};

export const statusOrderMap = {
    OVERDUE: 1,
    SUCCEEDED: 1,
    UNREAD: 2,
    OPEN: 3,
    ACTIVE: 3,
    CLOSED: 4,
    FAILED: 5,
};

export const additionalTableHeaderCells = [
    {
        id: "appraisedValueAmount",
        displayType: "CURRENCY",
        label: "Appraised Value Amount",
        sortValue: "",
        order: 8,
    },
    {
        id: "assessedValueAmount",
        displayType: "CURRENCY",
        label: "Assessed Value Amount",
        sortValue: "",
        order: 8,
    },
    {
        id: "appraisedValueCurrency",
        label: "Appraised Value Currency",
        sortValue: "",
        order: 8,
    },
    {
        id: "assessedValueCurrency",
        label: "Assessed Value Currency",
        sortValue: "",
        order: 8,
    },
    {
        id: "associatedPropertyType",
        label: "Associated Property Type",
        sortValue: "",
        order: 8,
    },
    {
        id: "bblCode",
        label: "BBL Code",
        sortValue: "",
        order: 8,
    },
    {
        id: "buildingCode",
        label: "Building Code",
        sortValue: "",
        order: 8,
    },
    {
        id: "buildingValueAmount",
        displayType: "CURRENCY",
        label: "Building Value Amount",
        sortValue: "",
        order: 8,
    },
    {
        id: "buildingValueCurrency",
        label: "Building Value Currency",
        sortValue: "",
        order: 8,
    },
    {
        id: "companyName",
        label: "Company Name",
        sortValue: "",
        order: 8,
    },
    {
        id: "discounts",
        label: "Discounts",
        sortValue: "",
        order: 8,
    },
    {
        id: "invoiceNumber",
        label: "Invoice Number",
        sortValue: "",
        order: 8,
    },
    {
        id: "landValueAmount",
        displayType: "CURRENCY",
        label: "Land Value Amount",
        sortValue: "",
        order: 8,
    },
    {
        id: "landValueCurrency",
        label: "Land Value Currency",
        sortValue: "",
        order: 8,
    },
    {
        id: "marketValueAmount",
        displayType: "CURRENCY",
        label: "Market Value Amount",
        sortValue: "",
        order: 8,
    },
    {
        id: "marketValueCurrency",
        label: "Market Value Currency",
        sortValue: "",
        order: 8,
    },
    {
        id: "numberOfPayments",
        label: "Number Of Payments",
        sortValue: "",
        order: 8,
    },
    {
        id: "taxDistrict",
        label: "Tax District",
        sortValue: "",
        order: 8,
    },
    {
        id: "taxableValueAmount",
        displayType: "CURRENCY",
        label: "Taxable Value Amount",
        sortValue: "",
        order: 8,
    },
    {
        id: "taxableValueCurrency",
        label: "Taxable Value Currency",
        sortValue: "",
        order: 8,
    },
    {
        id: "totalValueAmount",
        displayType: "CURRENCY",
        label: "Total Value Amount",
        sortValue: "",
        order: 8,
    },
    {
        id: "totalValueCurrency",
        label: "Total Value Currency",
        sortValue: "",
        order: 8,
    },
    {
        id: "trueAmountDueAmount",
        displayType: "CURRENCY",
        label: "True Amount Due",
        sortValue: "",
        order: 8,
    },
    {
        id: "trueAmountDueCurrency",
        label: "True Amount Due Currency",
        sortValue: "",
        order: 8,
    },
    {
        id: "artifactId",
        label: "Artifact Id",
        sortValue: "",
        order: 8,
    },
    {
        id: "updatedBy",
        label: "Updated By",
        sortValue: "",
        order: 8,
    },
];

export const additionalColumnsPrefers = [
    {
        id: "accountNumber",
        visible: false,
    },
    {
        id: "appealDeadline",
        visible: false,
    },
    {
        id: "appraisedValueAmount",
        visible: false,
    },
    {
        id: "appraisedValueCurrency",
        visible: false,
    },
    {
        id: "assessedValueAmount",
        visible: false,
    },
    {
        id: "assessedValueCurrency",
        visible: false,
    },
    {
        id: "assignedTo",
        visible: false,
    },
    {
        id: "associatedPropertyType",
        visible: false,
    },
    {
        id: "bblCode",
        visible: false,
    },
    {
        id: "buildingCode",
        visible: false,
    },
    {
        id: "buildingValueAmount",
        visible: false,
    },
    {
        id: "buildingValueCurrency",
        visible: false,
    },
    {
        id: "companyName",
        visible: false,
    },
    {
        id: "currency",
        visible: false,
    },
    {
        id: "discounts",
        visible: false,
    },
    {
        id: "dueDate",
        visible: false,
    },
    {
        id: "earliestPaymentDueDate",
        visible: false,
    },
    {
        id: "filingDueDate",
        visible: false,
    },
    {
        id: "invoiceNumber",
        visible: false,
    },
    {
        id: "address",
        subId: "jurisdiction",
        visible: false,
    },
    {
        id: "landValueAmount",
        visible: false,
    },
    {
        id: "landValueCurrency",
        visible: false,
    },
    {
        id: "mailId",
        visible: false,
    },
    {
        id: "marketValueAmount",
        visible: false,
    },
    {
        id: "marketValueCurrency",
        visible: false,
    },
    {
        id: "numberOfPayments",
        visible: false,
    },
    {
        id: "parcelNumber",
        visible: false,
    },
    {
        id: "propertyId",
        visible: false,
    },
    {
        id: "receiveDate",
        visible: false,
    },
    {
        id: "address",
        subId: "state",
        visible: false,
    },
    {
        id: "status",
        visible: false,
    },
    {
        id: "taxBillEstimateAmount",
        visible: false,
    },
    {
        id: "taxBillEstimateCurrency",
        visible: false,
    },
    {
        id: "taxDistrict",
        visible: false,
    },
    {
        id: "taxableValueAmount",
        visible: false,
    },
    {
        id: "taxableValueCurrency",
        visible: false,
    },
    {
        id: "totalTaxesOwedAmount",
        visible: false,
    },
    {
        id: "totalTaxesOwedCurrency",
        visible: false,
    },
    {
        id: "totalValueAmount",
        visible: false,
    },
    {
        id: "totalValueCurrency",
        visible: false,
    },
    {
        id: "trueAmountDueAmount",
        visible: false,
    },
    {
        id: "trueAmountDueCurrency",
        visible: false,
    },
    {
        id: "updatedBy",
        visible: false,
    },
    {
        id: "updatedOn",
        visible: false,
    },
    {
        id: "artifactId",
        visible: false,
    },
];
